/**
 * @generated SignedSource<<149a12d8da87276d8c2b9608574d1c9b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type rosettaConfigAppConfigQuery$variables = Record<PropertyKey, never>;
export type rosettaConfigAppConfigQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
};
export type rosettaConfigAppConfigQuery = {
  response: rosettaConfigAppConfigQuery$data;
  variables: rosettaConfigAppConfigQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "filter",
        "value": {
          "entityId": "rosetta"
        }
      }
    ],
    "concreteType": "AppConfigs",
    "kind": "LinkedField",
    "name": "appConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "json",
        "storageKey": null
      }
    ],
    "storageKey": "appConfig(filter:{\"entityId\":\"rosetta\"})"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "rosettaConfigAppConfigQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "rosettaConfigAppConfigQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "87b477af861f6ad77aa658a6944f2ae5",
    "id": null,
    "metadata": {},
    "name": "rosettaConfigAppConfigQuery",
    "operationKind": "query",
    "text": "query rosettaConfigAppConfigQuery {\n  appConfig(filter: {entityId: \"rosetta\"}) {\n    json\n  }\n}\n"
  }
};
})();

(node as any).hash = "6f94a6408d173e20bb7b38467308b96e";

export default node;
